export default __webpack_public_path__ + "d388b35c98f18eb296c569b1499127cc.svg";